import { forwardRef, useImperativeHandle, useRef } from 'react'

export type FileUploadProps = {
  onFileSelected(file: File): void
}

const FileUpload = forwardRef(({onFileSelected}: FileUploadProps, ref) => {
  const inputRef = useRef<any>()
  useImperativeHandle(ref, () => ({
    selectFile: () => {
      inputRef.current.click()
    }
  }))

  const handleFileSelected = (fileList: FileList | null) => {
    if (fileList === null || fileList.length === 0) {
      return
    }

    onFileSelected(fileList[0])
  }

  return <input
    ref={inputRef}
    type="file"
    style={{display: 'none'}}
    onChange={e => handleFileSelected(e.target.files)} 
  />
})

export default FileUpload